import { useEffect, useState } from 'react';

const ScarabEmblem = ({ className = "" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`scarab-emblem ${className}`} data-testid="scarab-emblem">
      {/* Glow effect */}
      <div className="scarab-glow" />
      
      {/* SVG Scarab - Structured, Robotic, Minimalist */}
      <svg 
        viewBox="0 0 100 100" 
        className="scarab-svg"
        style={{
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 1.5s ease-out'
        }}
      >
        {/* Outer hexagonal frame */}
        <path 
          d="M50 5 L85 25 L85 75 L50 95 L15 75 L15 25 Z" 
          className="scarab-path"
          style={{
            strokeDasharray: 280,
            strokeDashoffset: isVisible ? 0 : 280,
            transition: 'stroke-dashoffset 1.8s ease-out'
          }}
        />
        
        {/* Inner hexagonal frame */}
        <path 
          d="M50 15 L75 30 L75 70 L50 85 L25 70 L25 30 Z" 
          className="scarab-path"
          style={{
            strokeDasharray: 200,
            strokeDashoffset: isVisible ? 0 : 200,
            transition: 'stroke-dashoffset 1.5s ease-out 0.3s'
          }}
        />

        {/* Central body - robotic scarab core */}
        <rect 
          x="40" y="35" width="20" height="30" 
          className="scarab-path"
          style={{
            strokeDasharray: 100,
            strokeDashoffset: isVisible ? 0 : 100,
            transition: 'stroke-dashoffset 1.2s ease-out 0.5s'
          }}
        />
        
        {/* Head unit - geometric */}
        <path 
          d="M42 35 L50 25 L58 35" 
          className="scarab-path"
          style={{
            strokeDasharray: 40,
            strokeDashoffset: isVisible ? 0 : 40,
            transition: 'stroke-dashoffset 1s ease-out 0.7s'
          }}
        />
        
        {/* Top sensor/eye */}
        <circle 
          cx="50" cy="28" r="3" 
          className="scarab-path"
          style={{
            strokeDasharray: 19,
            strokeDashoffset: isVisible ? 0 : 19,
            transition: 'stroke-dashoffset 0.8s ease-out 0.9s'
          }}
        />

        {/* Left wing - angular robotic */}
        <path 
          d="M40 42 L25 38 L20 50 L25 62 L40 58" 
          className="scarab-path"
          style={{
            strokeDasharray: 80,
            strokeDashoffset: isVisible ? 0 : 80,
            transition: 'stroke-dashoffset 1.2s ease-out 0.6s'
          }}
        />
        
        {/* Right wing - angular robotic */}
        <path 
          d="M60 42 L75 38 L80 50 L75 62 L60 58" 
          className="scarab-path"
          style={{
            strokeDasharray: 80,
            strokeDashoffset: isVisible ? 0 : 80,
            transition: 'stroke-dashoffset 1.2s ease-out 0.6s'
          }}
        />

        {/* Body segmentation lines */}
        <line 
          x1="40" y1="45" x2="60" y2="45" 
          className="scarab-path"
          style={{
            strokeDasharray: 20,
            strokeDashoffset: isVisible ? 0 : 20,
            transition: 'stroke-dashoffset 0.8s ease-out 1s'
          }}
        />
        <line 
          x1="40" y1="55" x2="60" y2="55" 
          className="scarab-path"
          style={{
            strokeDasharray: 20,
            strokeDashoffset: isVisible ? 0 : 20,
            transition: 'stroke-dashoffset 0.8s ease-out 1.1s'
          }}
        />

        {/* Central core indicator */}
        <circle 
          cx="50" cy="50" r="4" 
          className="scarab-path"
          style={{
            strokeDasharray: 25,
            strokeDashoffset: isVisible ? 0 : 25,
            transition: 'stroke-dashoffset 0.8s ease-out 1.2s'
          }}
        />

        {/* Lower legs - geometric */}
        <line 
          x1="42" y1="65" x2="35" y2="75" 
          className="scarab-path"
          style={{
            strokeDasharray: 15,
            strokeDashoffset: isVisible ? 0 : 15,
            transition: 'stroke-dashoffset 0.6s ease-out 1.3s'
          }}
        />
        <line 
          x1="58" y1="65" x2="65" y2="75" 
          className="scarab-path"
          style={{
            strokeDasharray: 15,
            strokeDashoffset: isVisible ? 0 : 15,
            transition: 'stroke-dashoffset 0.6s ease-out 1.3s'
          }}
        />
        
        {/* Corner accents */}
        <line 
          x1="20" y1="20" x2="30" y2="25" 
          className="scarab-path"
          style={{
            strokeDasharray: 12,
            strokeDashoffset: isVisible ? 0 : 12,
            transition: 'stroke-dashoffset 0.5s ease-out 1.5s'
          }}
        />
        <line 
          x1="80" y1="20" x2="70" y2="25" 
          className="scarab-path"
          style={{
            strokeDasharray: 12,
            strokeDashoffset: isVisible ? 0 : 12,
            transition: 'stroke-dashoffset 0.5s ease-out 1.5s'
          }}
        />
        <line 
          x1="20" y1="80" x2="30" y2="75" 
          className="scarab-path"
          style={{
            strokeDasharray: 12,
            strokeDashoffset: isVisible ? 0 : 12,
            transition: 'stroke-dashoffset 0.5s ease-out 1.5s'
          }}
        />
        <line 
          x1="80" y1="80" x2="70" y2="75" 
          className="scarab-path"
          style={{
            strokeDasharray: 12,
            strokeDashoffset: isVisible ? 0 : 12,
            transition: 'stroke-dashoffset 0.5s ease-out 1.5s'
          }}
        />
      </svg>
    </div>
  );
};

export default ScarabEmblem;
